module.exports = __webpack_public_path__ + "static/artist-management-the-process-mobile-6dcf1d686542d8dd47fa67b39a0abc0b.webp";